import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-shadow */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Input } from '../Input';
import { Icon, Button } from '../../subkit-ui';
import { Information } from '../Information';
import { validateEmail, validateUsername } from '../../utils/helpers';
import { forbiddenUsernames } from '../../utils/constants';
import prospectService from '../../services/prospect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var ProspectForm = function ProspectForm(_ref) {
  var parentFeedback = _ref.parentFeedback,
      classes = _ref.classes,
      saveProspect = _ref.saveProspect,
      handleFeedback = _ref.handleFeedback;

  var _useState = useState({
    name: {
      username: '',
      usernameAvailable: false
    },
    emailAddress: {
      email: '',
      emailValid: false
    },
    feedback: {
      info: '',
      error: '',
      loading: false
    }
  }),
      localState = _useState[0],
      setLocalState = _useState[1];

  var updateLocalState = function updateLocalState(updates) {
    var newState = _objectSpread(_objectSpread({}, localState), updates);

    setLocalState(newState);
  };

  var _localState$name = localState.name,
      username = _localState$name.username,
      usernameAvailable = _localState$name.usernameAvailable,
      _localState$emailAddr = localState.emailAddress,
      email = _localState$emailAddr.email,
      emailValid = _localState$emailAddr.emailValid,
      feedback = localState.feedback;
  var error = feedback.error,
      info = feedback.info,
      loading = feedback.loading;
  var btnDisabled = loading ? true : usernameAvailable ? !emailValid : false;
  var usernameValid = validateUsername(username);

  var getProspectStatus = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var _username, _localState$emailAddr2, _email, _emailValid, prospectAvailable;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              if (!(btnDisabled || !usernameValid)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _username = localState.name.username, _localState$emailAddr2 = localState.emailAddress, _email = _localState$emailAddr2.email, _emailValid = _localState$emailAddr2.emailValid;
              handleFeedback('', '', true);
              _context.next = 8;
              return prospectService.check({
                username: _username,
                email: _email
              });

            case 8:
              prospectAvailable = _context.sent;

              if (prospectAvailable) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              if (prospectAvailable && !_email) {
                updateLocalState({
                  name: {
                    username: _username,
                    usernameAvailable: true
                  }
                });
                handleFeedback('', 'You’re in luck! It’s available.', false);
              }

              if (_emailValid) saveProspect(_username, _email);else if (_email) handleFeedback('Please use a valid email address', '', false);
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              handleFeedback(_context.t0, '', false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 15]]);
    }));

    return function getProspectStatus(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(name, value) {
    switch (name) {
      case 'username':
        if (validateUsername(value)) {
          handleFeedback('', '', false);
        } else {
          var message = 'Please remove spaces and special characters.';
          if (forbiddenUsernames.includes(value)) message = 'Username not available';
          handleFeedback(message, '', false);
        }

        updateLocalState({
          name: {
            username: value,
            usernameAvailable: false
          }
        });
        break;

      case 'email':
        updateLocalState({
          emailAddress: {
            email: value,
            emailValid: validateEmail(value),
            confirmationSent: false
          }
        });
        break;

      default:
        break;
    }
  };

  useEffect(function () {
    if (parentFeedback !== feedback) {
      updateLocalState({
        feedback: parentFeedback
      });
    }
  });
  var showButton = usernameAvailable && !!username || usernameValid;
  return /*#__PURE__*/_jsxs("form", {
    className: "flex flex-column mb2 prospect-form ".concat(classes),
    onSubmit: getProspectStatus,
    autoComplete: "new-password",
    children: [/*#__PURE__*/_jsx(Information, {
      heading: "Turn your \u201Cone day\u201D into day one.",
      subHeading: "Reserve your username"
    }), /*#__PURE__*/_jsx(Input, {
      format: "rounded",
      label: "subkit.com/",
      icon: usernameAvailable && {
        name: 'check-circle',
        className: 'c-success'
      },
      classes: {
        input: 'w-fill'
      },
      inputValue: username,
      name: "username",
      onInputChange: handleChange,
      hasFocus: !usernameAvailable
    }), /*#__PURE__*/_jsx(Input, {
      format: "rounded",
      label: "Email address",
      name: "email",
      inputType: "email",
      inputValue: email,
      classes: {
        container: classNames({
          'display-none': !usernameAvailable
        }),
        input: 'w-fill'
      },
      onInputChange: handleChange,
      hasFocus: usernameAvailable
    }), /*#__PURE__*/_jsx("p", {
      className: classNames('h5', {
        'c-danger': error,
        'c-success': !error && info,
        'display-none': !error && !info
      }),
      children: error || info
    }), showButton && /*#__PURE__*/_jsx(Button, {
      text: usernameAvailable ? 'Reserve' : 'Check availability',
      disabled: btnDisabled && usernameValid
    }), /*#__PURE__*/_jsxs("span", {
      className: "self-baseline h2 mb2 mt1 display-none",
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "twitter",
        type: "brand",
        className: "c-gray-2 clickable mr2"
      }), /*#__PURE__*/_jsx(Icon, {
        name: "instagram",
        type: "brand",
        className: "c-gray-2 clickable mr2"
      })]
    })]
  });
};